<template>
<div class="chapter">
<div class="inner_page">
<div id="a08_fm">
<a id="page_10">
</a><div class="boxm"><a id="page_10">
</a><p class="bpara"><a id="page_10"><span class="small"><b>A NOTE ABOUT THE PHOTOS IN THIS BOOK:</b></span> <i>The wrecked medium tanks on Tarawa were extensively photographed; most of those photos are available in a number of sources so only those specifically related to the text are reproduced here. Similarly, only selected aerial photos used in analysis are reproduced here for space reasons. Some period snapshots are not reproduced because resolution is inadequate for printing. Many of these photos—particularly personal snapshots showing the personnel of Charlie Company—can be seen at</i> </a><a href="http://tanksontarawa.com" target="_blank">tanksontarawa.com</a>, <i>and</i> <a href="http://tarawaontheweb.org" target="_blank">tarawaontheweb.org</a>. <i>Other photos exist but resolution is too poor for publication, or the copyright provenance is unclear.</i></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_fm.vue?7b242d1a